module.exports = {
  apiversion: '1.0',
  region: 'ch',
  showforgotpassword: true,
  e_cred_pin: true,
  branchCode: 4,
  uploadFileMaxSize: 10485760,
  upload5MB: 5242880,
  chunkSize: 2000000,
  parallelCallCount: 2,
  activetimeout: 60000,
  logoutdebug: false,
  assetPageSizeApp: 25,       //WMCE-21564- To change asset page record size in app
  assetPageSize: 200,         //WMCE-21564 To change page size in asset 
  chat: {
    enabled: true,
    // to enable/disable attachment in web/App
    enableAttachment: false,
    websocketurls: {
      "https://uat3.deutschewealthonline.db.com": "wss://uat5.mywealthasia.intranet.db.com/wsreq",
      "https://deutschewealthonline.db.com": "wss://deutschewealthonline.intranet.db.com/wsreq"
    }
  },
  // Feature/EBANK-17839 create app without rendering
  // trading:{
  //   tradeComponentDisabled: false
  // }
  showOrderReport: true,       // WMCE-36542 - 'Order Report' button must be visible only if a configuration property is set to true
  isAirLockUpgrade: true,
  isManageContactDetailsEnabled: true,
  isEDocumentSettingsEnabled: true,
  labelAccessibilityInfoEnglish: "Accessibility Statement", //WMCE-51634
  labelAccessibilityInfoGerman: "Erklärung zur Barrierefreiheit",
  isVopEnabled: true,
  isSepaIPEnabled: true,  
  enableStructuredAddress: true,
}
